import autoHeight from './modules/autoHeight';
import lazyLoad from './modules/lazyLoad';
import mobileSide from './modules/mobileSide';
//import changeMainBg from './modules/changeMainBg';
import modal from './modules/modal';
import flycart from './modules/flycart';
import order from './modules/order';
import tabs from './modules/tabs';
//import inpitMask from './modules/inpitMask';
import sliders from './modules/sliders';
import lightbox from './modules/lightbox';
import sizes from './modules/sizes';
import customOrder from './modules/customOrder';
import age from './modules/age';
import country_modal from './modules/country_modal';
import accordion from './modules/accordion';
import form from './modules/form';
import stickyHeader from './modules/stickyHeader';

require('./scripts');